import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {jwtDecode} from 'jwt-decode';
import api from '../../api/api';



const LogIn = () => {
  const [loginDetails, setLoginDetails] = useState({businessCode: "", username: "", password: ""})
  const [formError, setFormError] = useState("")
  const navigate = useNavigate()
  const location = useLocation();


  const from = location?.state?.from;

  const handleChange = (e) => {
    const {name, value} = e.target
    setLoginDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value
    }))
  }

  const validate = () => {
    if(!loginDetails.businessCode){
      setFormError("Business code is required!")
      return 
    } 
    if(!loginDetails.username){
      setFormError("Username is required!")
      return
    } 
    if(!loginDetails.password){
      setFormError("Password is required!")
      return
    }
    return ""
  }

  // useEffect(() => {
  //   const token = localStorage.getItem("token")
  //   if(token){
  //     navigate('/dashboard')
  //   }

  // })

  const handleSignIn = async (e) => {
    e.preventDefault();
    setFormError('')
    var isValidated = validate() === '' ? true : false

    if(isValidated){
      try{
        const response = await api.post('/auth/login', {
          businessCode: loginDetails.businessCode,
          username: loginDetails.username,
          password: loginDetails.password
        })
        
        if(response.data.errorMsg){
          setFormError(response.data.errorMsg)
          return
        }

        localStorage.setItem('token', response.data.token)

        const decoded = jwtDecode(response.data.token);

        localStorage.setItem('userDetails', JSON.stringify({
          firstName: decoded.firstName,
          lastName: decoded.lastName,
          accountType: decoded.accountType
        }))

        if(from?.pathname === '/attendance'){
          navigate(from.pathname + from.search, { replace: true });
          return
        }else{
          navigate('/dashboard', { replace: true })
        }
        
        
      }catch(error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errorMsg
        ) {
          setFormError(error.response.data.errorMsg);
        }
      }
    }
  }

  return (
    <div className='flex min-h-full flex-col justify-center px-6 py-12 lg:px-8'>
      <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
        
        <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Sign in to your account</h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6" onSubmit={handleSignIn}>
          <div>
            <label htmlFor="businessCode" className="block text-sm/6 font-medium text-gray-900">Business code</label>
            <div className="mt-2 grid grid-cols-1">
              <input id="businessCode" name="businessCode" onChange={handleChange} value={loginDetails.businessCode} type="text" autoComplete="business-code" required className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"/>
            </div>
          </div>

          <div>
            <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900">Username</label>
            <div className="mt-2">
              <input id="username" name="username" onChange={handleChange} value={loginDetails.username} type="text" autoComplete="username" required className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"/>
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">Password</label>
              <div className="text-sm">
                <Link to="/" className="font-semibold text-indigo-600 hover:text-indigo-500">Forgot password?</Link>
              </div>
            </div>
            <div className="mt-2">
              <input id="password" name="password" type="password" onChange={handleChange} value={loginDetails.password}  autoComplete="current-password" required className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"/>
            </div>
          </div>
          {
            formError &&
            <p id="email-error" className="mt-2 text-sm text-red-600">
              {formError}
            </p>
          }
          

          <div>
            <button type="submit" className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Sign in</button>
          </div>
        </form>

        <p className="mt-10 text-center text-sm/6 text-gray-500">
          Not a member?
          <Link to="/sign-up" className="font-semibold text-indigo-600 hover:text-indigo-500"> Sign up now</Link>
        </p>
      </div>
    </div>
  )
}

export default LogIn